import api from "./api";


 export const Defaultpageifl ={
 
    getLiveAlerts(payload){
        return api.put (`/facial/get_live_logs`,payload);

    },
    getLiveAlertss(payload){
        return api.put (`/facial/get_live_logss`,payload);

    },

    getLivecounts(payload){
        return api.put (`/facial/get_logs_count`,payload);

    },

    getStats(payload){
        return api.put (`/facial/get_stats`,payload);

    },
    
    getCameraStatus(payload){
        return api.put (`/facial/camera_status`,payload);
    },

    getAIModelPerformance(payload){
        return api.put (`/facial/daily_movement_summary`,payload);
    }



}



